import React from "react";

import PropTypes from "prop-types";
import Box from "@mui/material/Box";

export function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

// implementation of MUI full-width tabs
function StyledTabPanel({
  children,
  borderRadius,
  disableBoxShadow,
  index,
  maxHeight,
  mt,
  p,
  value,
  ...other
}) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      style={{
        maxHeight: maxHeight ? maxHeight : "calc(100vh - 204px)",
        display: "flex",
        width: "100%",
      }}
    >
      {value === index && <Box sx={{ width: "100%" }}>{children}</Box>}
    </div>
  );
}

StyledTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default StyledTabPanel;
